export default {
	path: '/',
	icon: '',
	meta: {
		title: '开疆管理'
	},
	children: [
		{
			path: '/KJ/home',
			name: 'KJHomeIndex',
			icon: '',
			ignore: true, //忽略权限校验
			component: () => import('@/views/kaijiang/home'),
			meta: {
				title: '公告数据库'
			}
		},
		{
			path: '/KJ/onAndOffLine',
			name: 'OnAndOffLineIndex',
			icon: '',
			ignore: true, //忽略权限校验
			component: () => import('@/views/kaijiang/onAndOffLine/index'),
			meta: {
				title: '线上线下数据'
			}
		},
		{
			path: '/KJ/visualization',
			name: 'VisualizationIndex',
			icon: '',
			ignore: true, //忽略权限校验
			component: () => import('@/views/kaijiang/onAndOffLine/visualization'),
			meta: {
				title: '数据可视化'
			}
		},
		// {
		// 	path: '/KJ/marketplace',
		// 	icon: '',
		// 	ignore: true, //忽略权限校验
		// 	component: () => import('@/views/kaijiang/marketplace/index'),
		// 	meta: {
		// 		title: '市场活动'
		// 	}
		// },
		// {
		// 	path: '/KJ/profile',
		// 	icon: '',
		// 	ignore: true, //忽略权限校验
		// 	component: () => import('@/views/kaijiang/profile/index'),
		// 	meta: {
		// 		title: '资料管理'
		// 	}
		// },
		{
			path: '/KJ/panel',
			name: 'MarketplacePanelIndex',
			icon: '',
			ignore: true, //忽略权限校验
			hideSide: true, //隐藏左侧菜单
			component: () => import('@/views/kaijiang/marketplace/panel'),
			meta: {
				title: '线索管理'
			}
		},
		{
			path: '/KJ/statistics',
			name: 'StatisticsIndex',
			icon: '',
			ignore: true, //忽略权限校验
			component: () => import('@/views/kaijiang/statistics'),
			meta: {
				title: '资源统计'
			}
		},
		{
			path: '/KJ/hotSpot',
			name: 'HotSpotIndex',
			icon: '',
			ignore: true, //忽略权限校验
			component: () => import('@/views/kaijiang/hotSpot'),
			meta: {
				title: '全网热点'
			}
		},
		{
			path: '/',
			icon: '',
			ignore: true, //忽略权限校验
			component: '',
			meta: {
				title: '推广平台检测'
			},
			children: [
				{
					path: '/KJ/works/accountList',
					name: 'AccountListIndex',
					icon: '',
					ignore: true, //忽略权限校验
					component: () => import('@/views/kaijiang/works/accountList'),
					meta: {
						title: '账号列表'
					}
				},
				{
					path: '/KJ/works/monitorWorks',
					name: 'monitorWorksIndex',
					icon: '',
					ignore: true, //忽略权限校验
					component: () => import('@/views/kaijiang/works/monitorWorks'),
					meta: {
						title: '作品列表'
					}
				}
			]
		}

		// {
		// 	path: '/',
		// 	icon: '',
		// 	component: '',
		// 	meta: {
		// 		title: '学练模块'
		// 	},
		// 	children: [
		// 		{
		// 			path: '/KJ/officType',
		// 			icon: '',
		// 			component: () => import('@/views/kaijiang/learnToPractice/officType/index'),
		// 			power: 'admin/v1/day',
		// 			meta: {
		// 				title: '公职类型管理'
		// 			}
		// 		},
		// 		{
		// 			path: '/KJ/PDM/dataList',
		// 			icon: '',
		// 			component: () => import('@/views/kaijiang/learnToPractice/PDM/dataList'),
		// 			power: 'admin/v1/day',
		// 			meta: {
		// 				title: '资料管理'
		// 			}
		// 		},
		// 		{
		// 			path: '/KJ/PDM/dataBase',
		// 			icon: '',
		// 			component: () => import('@/views/kaijiang/learnToPractice/PDM/dataBase'),
		// 			power: 'admin/v1/day',
		// 			meta: {
		// 				title: '资料库管理'
		// 			}
		// 		},
		// 		{
		// 			path: '/KJ/PDM/dataCollection',
		// 			icon: '',
		// 			component: () => import('@/views/kaijiang/learnToPractice/PDM/dataCollection'),
		// 			power: 'admin/v1/day',
		// 			meta: {
		// 				title: '资料合集管理'
		// 			}
		// 		},
		// 		{
		// 			path: '/KJ/brushingQuestions/topicType',
		// 			icon: '',
		// 			component: () =>
		// 				import('@/views/kaijiang/learnToPractice/brushingQuestions/topicType/topicType'),
		// 			power: 'admin/v1/day',
		// 			meta: {
		// 				title: '题库类型'
		// 			}
		// 		},
		// 		{
		// 			path: '/KJ/brushingQuestions/questionBank',
		// 			icon: '',
		// 			component: () =>
		// 				import('@/views/kaijiang/learnToPractice/brushingQuestions/questionBank/questionBank'),
		// 			power: 'admin/v1/day',
		// 			meta: {
		// 				title: '题库管理'
		// 			}
		// 		},
		// 		{
		// 			path: '/brushingQuestions/examManagement',
		// 			icon: '',
		// 			component: () =>
		// 				import(
		// 					'@/views/kaijiang/learnToPractice/brushingQuestions/examManagement/examManagement'
		// 				),
		// 			power: 'admin/v1/day',
		// 			meta: {
		// 				title: '试卷管理'
		// 			}
		// 		},
		// 		{
		// 			path: '/KJ/LPmangement',
		// 			icon: '',
		// 			component: () => import('@/views/kaijiang/learnToPractice/LPmangement/index'),
		// 			power: 'admin/v1/day',
		// 			meta: {
		// 				title: '每日学练管理'
		// 			}
		// 		}
		// 	]
		// }
	]
}
